"use strict";

var _slicedToArray = require("/home/circleci/project/web-front/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/slicedToArray");
var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault").default;
var _interopRequireWildcard = require("@babel/runtime/helpers/interopRequireWildcard").default;
Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;
var _react = _interopRequireWildcard(require("react"));
var _styledComponents = _interopRequireWildcard(require("styled-components"));
var _flexComponents = require("../../atoms/flex-components");
var _styles = require("../../shared/styles");
var _TableRow = _interopRequireDefault(require("./TableRow"));
var _jsxRuntime = require("react/jsx-runtime");
var Offset = _styledComponents.default.div.withConfig({
  displayName: "TableRowNested__Offset",
  componentId: "sc-1410wz6-0"
})(["", ""], function (_ref) {
  var leftOffset = _ref.leftOffset;
  return leftOffset && (0, _styledComponents.css)(["margin-left:", "px;"], leftOffset);
});
var Indent = _styledComponents.default.div.withConfig({
  displayName: "TableRowNested__Indent",
  componentId: "sc-1410wz6-1"
})(["height:", "px;width:", "px;border-left:solid 1px ", ";border-bottom:solid 1px ", ";border-radius:2px;"], function (_ref2) {
  var height = _ref2.height;
  return height;
}, function (_ref3) {
  var width = _ref3.width;
  return width;
}, _styles.colors.border.primary.default, _styles.colors.border.primary.default);
var Next = _styledComponents.default.div.withConfig({
  displayName: "TableRowNested__Next",
  componentId: "sc-1410wz6-2"
})(["height:", "px;width:", "px;", "}"], function (_ref4) {
  var height = _ref4.height;
  return height;
}, function (_ref5) {
  var width = _ref5.width;
  return width;
}, function (_ref6) {
  var isLastRow = _ref6.isLastRow;
  return !isLastRow && (0, _styledComponents.css)(["border-left:solid 1px ", ";"], _styles.colors.border.primary.default);
});
var TableRowNested = function TableRowNested(_ref7) {
  var children = _ref7.children,
    onClick = _ref7.onClick,
    leftOffset = _ref7.leftOffset,
    isLast = _ref7.isLast;
  var rowRef = (0, _react.useRef)();
  var _ref8 = (0, _react.useState)(),
    _ref9 = _slicedToArray(_ref8, 2),
    height = _ref9[0],
    setHeight = _ref9[1];
  (0, _react.useLayoutEffect)(function () {
    var _rowRef$current;
    setHeight((_rowRef$current = rowRef.current) === null || _rowRef$current === void 0 ? void 0 : _rowRef$current.offsetHeight);
  }, []);
  return /*#__PURE__*/(0, _jsxRuntime.jsx)(Offset, {
    leftOffset: leftOffset / 2,
    children: /*#__PURE__*/(0, _jsxRuntime.jsxs)(_flexComponents.FlexRow, {
      children: [/*#__PURE__*/(0, _jsxRuntime.jsxs)(_flexComponents.FlexColumn, {
        gap: '0',
        flex: '0',
        children: [/*#__PURE__*/(0, _jsxRuntime.jsx)(Indent, {
          height: height / 2,
          width: leftOffset / 2
        }), /*#__PURE__*/(0, _jsxRuntime.jsx)(Next, {
          isLastRow: isLast,
          height: height / 2,
          width: leftOffset / 2
        })]
      }), /*#__PURE__*/(0, _jsxRuntime.jsx)(_TableRow.default, {
        ref: rowRef,
        onClick: onClick,
        children: children
      })]
    })
  });
};
TableRowNested.defaultProps = {};
var _default = exports.default = TableRowNested;